import { memo } from 'react';
import type { StartOrderingButtonProps } from './types';

export const StartOrderingButton = memo(function StartOrderingButton({
  onClick,
  label,
}: StartOrderingButtonProps) {
  return (
    <button type="button" className="btn" onClick={onClick}>
      {label}
    </button>
  );
});
